import { Form } from 'react-router'
import { ImageField } from '../../molecules/form/ImageField.tsx'

export type PerformerFormActionData = {
	errors?: {
		name?: string
		slug?: string
		server?: string
	}
}

interface PerformerFormProps {
	performer?: {
		id: string
		slug: string
		name: string
		shortBio?: string | null
		bio?: string | null
		imageUrl?: string | null
		imageSafeZone?: string | null
	}
	actionData?: PerformerFormActionData
	isEditing?: boolean
	showSlug?: boolean
}

export function PerformerForm({
	performer,
	actionData,
	isEditing = false,
	showSlug = true,
}: PerformerFormProps) {
	return (
		<Form method="post" encType="multipart/form-data" className="space-y-4">
			<div className="form-control">
				<label htmlFor="name" className="label">
					<span className="label-text">Namn</span>
				</label>
				<input
					type="text"
					id="name"
					name="name"
					required
					className="input input-bordered"
					defaultValue={performer?.name ?? ''}
				/>
				{actionData?.errors?.name && (
					<p className="mt-1 text-error">{actionData.errors.name}</p>
				)}
			</div>
			{showSlug && (
				<div className="form-control">
					<label htmlFor="slug" className="label">
						<span className="label-text">
							Lenkje
							<span className="text-xs text-base-content/50">
								{' '}
								- (tom = automatisk frå namnet)
							</span>
						</span>
					</label>
					<input
						type="text"
						id="slug"
						name="slug"
						className="input input-bordered"
						defaultValue={performer?.slug ?? ''}
						placeholder="t.d. arne-skorpe-sjoen"
					/>
					{actionData?.errors?.slug && (
						<p className="mt-1 text-error">{actionData.errors.slug}</p>
					)}
				</div>
			)}
			<div className="form-control">
				<label htmlFor="shortBio" className="label">
					<span className="label-text">Kort presentasjon</span>
				</label>
				<input
					type="text"
					id="shortBio"
					name="shortBio"
					className="input input-bordered"
					maxLength={200}
					defaultValue={performer?.shortBio ?? ''}
					placeholder="Omtale på éi linje som blir vist på artistlista"
				/>
			</div>
			<div className="form-control">
				<label htmlFor="bio" className="label">
					<span className="label-text">
						Biografi
						<span className="text-xs text-base-content/50"> - (markdown)</span>
					</span>
				</label>
				<textarea
					id="bio"
					name="bio"
					className="textarea textarea-bordered h-48"
					defaultValue={performer?.bio ?? ''}
					placeholder={'Fortel om artisten. T.d.:\n\n## Om artisten\n\n...'}
				/>
			</div>
			<ImageField
				name="photo"
				initialImageUrl={performer?.imageUrl || null}
				label="Bilete"
				crop={{ mode: 'free' }}
				safeZone={{
					initial: performer?.imageSafeZone,
					// every portrait (list, artist page, round avatar) is square
					frames: [{ label: 'Portrett', aspect: 1 }],
				}}
				helpText="Heile biletet blir teke vare på. Merk ei trygg sone rundt andlet eller instrument, så blir det alltid med."
			/>
			<button type="submit" className="btn btn-primary">
				{isEditing ? 'Oppdater artist' : 'Opprett artist'}
			</button>
			{actionData?.errors?.server && (
				<p className="text-error">{actionData.errors.server}</p>
			)}
		</Form>
	)
}
